const GenreSkeleton = () => {
  const arr = [1, 2, 3, 4, 5, 6];
  return (
    <div>
      <div className="mt-4 flex w-full flex-row items-center justify-between">
        <div className="h-5 w-20 animate-pulse rounded bg-[#1a1919]"></div>
        <div className="h-4 w-14 animate-pulse rounded bg-[#1a1919]"></div>
      </div>
      <div className="grid w-full grid-cols-2 grid-rows-3 gap-3 pt-5 max-sm:grid-cols-2">
        {arr.map((item) => (
          <div
            key={item}
            className="h-20 w-[97%] animate-pulse rounded-lg bg-[#1a1919]"
          ></div>
        ))}
      </div>
    </div>
  );
};

export default GenreSkeleton;
